import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LangProvider } from "./i18n";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Terms from "./pages/Terms";
import CookieBanner from "./components/CookieBanner";
import SmoothScroll from "./components/SmoothScroll";

function ScrollToTopOnRoute() {
  const { pathname, search } = useLocation();
  const prev = React.useRef({ pathname, search });

  useEffect(() => {
    // Do NOT scroll on pure language switch (same suffix path, different lang prefix)
    const stripLang = (p) => p.replace(/^\/(ar|en)/, "") || "/";
    const prevStripped = stripLang(prev.current.pathname);
    const currStripped = stripLang(pathname);
    const isLangSwitchOnly =
      prev.current.pathname !== pathname && prevStripped === currStripped;

    if (!isLangSwitchOnly) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    prev.current = { pathname, search };
  }, [pathname, search]);
  return null;
}

function AppShell() {
  return (
    <LangProvider>
      <ScrollToTopOnRoute />
      <SmoothScroll />
      <Routes>
        {/* Root redirects to Spanish */}
        <Route path="/" element={<Navigate to="/ar" replace />} />

        {/* Thank you (Spanish only, fixed at /thank_you) */}
        <Route path="/thank_you" element={<ThankYou />} />

        {/* Language sections */}
        <Route path="/ar" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="terms-conditions" element={<Terms />} />
        </Route>
        <Route path="/en" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="terms-conditions" element={<Terms />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
      <CookieBanner />
    </LangProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
